import React, { useContext } from 'react'
import HomeThings from './MainHome/HomeThings.jsx'
import { makeStyles, Grid, Box, Typography } from '@material-ui/core'

import { ProductsContext } from '../../contexts/ProductsContext.jsx'

const MainHome = () => {
  const { setSearchQuery, setInputText, setCurrPage } =
    useContext(ProductsContext)

  const useStyles = makeStyles((theme) => ({
    thingsCtn: {
      margin: 0,
      maxWidth: '100%'
    },
    heading: {
      fontWeight: 'bold'
    },
    subheading: {
      color: theme.palette.grey[700]
    },
    everything: {
      
    },
    introImgStyle: {
      maxWidth: 350
    }
  }))

  const classes = useStyles()

  const things = ['Accessories', 'Dress', 'Makeup', 'Pants', 'Shoes', 'Suits']

  return (
    <Grid container component="section" id="home">
      <Grid item xs={12}>
        <Box
          display="flex"
          flexDirection="column"
          alignItems="center"
          justifyContent="center"
          height={'90vh'}
        >
          <Box>
            <img
              className={classes.introImgStyle}
              src="/img/introImg.jpg"
              alt="products"
            />
          </Box>
          <Typography variant="h2" className={classes.heading}>Welcome to Shopy!</Typography>
          <Typography variant="h5" className={classes.subheading}>Like Products. Like Never Before.</Typography>
        </Box>
      </Grid>
      <Grid item xs={12}>
        <Box>
          <Typography variant="h3" paragraph align="center" className={classes.everything}>
            Everything in one place
          </Typography>
          <Grid
            className={classes.thingsCtn}
            container
            spacing={4}
            justify="center"
          >
            {things.map((thing) => (
              <HomeThings
                key={thing}
                thing={thing}
                setSearchQuery={setSearchQuery}
                setInputText={setInputText}
                setCurrPage={setCurrPage}
              />
            ))}
          </Grid>
        </Box>
      </Grid>
    </Grid>
  )
}

export default MainHome
